import { cn } from "@/lib/utils";

export function TypingBubble() {
  return (
    <div className="flex gap-3 w-full max-w-screen-md mx-auto">
      <div className="h-8 w-8 flex-shrink-0" /> {/* Avatar space placeholder */}
      <div className={cn(
        "rounded-lg px-4 py-2 max-w-[85%] bg-muted flex items-center gap-1"
      )}>
        <span className="w-2 h-2 rounded-full bg-foreground/50 animate-bounce" style={{ animationDelay: "0ms" }} />
        <span className="w-2 h-2 rounded-full bg-foreground/50 animate-bounce" style={{ animationDelay: "150ms" }} />
        <span className="w-2 h-2 rounded-full bg-foreground/50 animate-bounce" style={{ animationDelay: "300ms" }} />
      </div>
    </div>
  );
}